import { Button } from '@ordo/ui/button'
import { CheckCircle2, MailWarning } from 'lucide-react'

import { smsReplyNotice } from '../../lib/sender-options'
import { isSmsSender, type Sender } from '../../types/senders'

export function VerificationBanner({
  sender,
  onResend,
  resending,
}: {
  sender: Sender
  onResend: () => void
  resending: boolean
}) {
  if (isSmsSender(sender)) {
    return (
      <div className="rounded-md border bg-muted/30 p-4 text-sm">
        <p className="font-medium">
          {sender.isDefault ? 'Default SMS sender' : sender.active ? 'Active SMS sender' : 'Inactive SMS sender'}
        </p>
        <p className="mt-1 text-muted-foreground">{sender.phoneNumber}</p>
        <p className="mt-1 text-muted-foreground">
          {sender.verified ? 'Number ownership verified with Twilio.' : 'Number verification needs attention.'}
        </p>
        <p className="mt-1 text-muted-foreground">{smsReplyNotice(sender)}</p>
        {sender.isDefault ? (
          <p className="mt-1 text-muted-foreground">
            Managed by the configured Twilio default in Integrations. Configure ordinary reply forwarding in Inbound.
          </p>
        ) : null}
      </div>
    )
  }
  if (sender.verified) {
    return (
      <div className="flex items-start gap-3 rounded-md border border-emerald-500/30 bg-emerald-500/10 p-4">
        <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-emerald-500" />
        <div className="text-sm">
          <p className="font-medium text-emerald-600 dark:text-emerald-400">Verified</p>
          <p className="mt-1 text-muted-foreground">This sender is ready to use as a from-address.</p>
        </div>
      </div>
    )
  }
  return (
    <div className="flex items-start justify-between gap-3 rounded-md border border-amber-500/30 bg-amber-500/10 p-4">
      <div className="flex items-start gap-3">
        <MailWarning className="mt-0.5 h-5 w-5 shrink-0 text-amber-500" />
        <div className="text-sm">
          <p className="font-medium text-amber-500">Pending verification</p>
          <p className="mt-1 text-muted-foreground">
            SendGrid sent a verification email to <strong>{sender.fromEmail}</strong>. Click the link in that email
            before this sender can be used.
          </p>
        </div>
      </div>
      <Button size="sm" variant="outline" onClick={onResend} disabled={resending}>
        {resending ? 'Sending...' : 'Resend email'}
      </Button>
    </div>
  )
}
